module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.3b396895.ttf";